import { z } from "zod";
import {
  CONTENT_REDACTION_POLICY_NAMES,
  CONTENT_SCREENING_PROVIDER_NAMES
} from "./types.js";
const contentScreeningProviderNameSchema = z.enum(
  CONTENT_SCREENING_PROVIDER_NAMES
);
const contentRedactionPolicySchema = z.enum(
  CONTENT_REDACTION_POLICY_NAMES
);
const contentScreeningDetectionSchema = z.object({
  start: z.number().int().nonnegative(),
  end: z.number().int().positive(),
  entityType: z.string().min(1),
  score: z.number().min(0).max(1)
}).refine(({ start, end }) => end > start, {
  message: "Detection end must be greater than start",
  path: ["end"]
});
const contentScreeningDetectionsSchema = z.array(
  contentScreeningDetectionSchema
);
function isContentScreeningDetectionWithinText(text, detection) {
  return Number.isInteger(detection.start) && Number.isInteger(detection.end) && detection.start >= 0 && detection.end > detection.start && detection.end <= text.length && isUtf16Boundary(text, detection.start) && isUtf16Boundary(text, detection.end);
}
const contentScreeningProviderResultSchema = z.object({
  provider: contentScreeningProviderNameSchema,
  screenedAt: z.iso.datetime(),
  detections: contentScreeningDetectionsSchema
});
const textContentScreeningSchema = z.object({
  providers: z.array(contentScreeningProviderResultSchema).min(1)
}).superRefine(({ providers }, context) => {
  const names = providers.map(({ provider }) => provider);
  if (new Set(names).size !== names.length) {
    context.addIssue({
      code: "custom",
      message: "Screening providers must be unique",
      path: ["providers"]
    });
  }
});
function isUtf16Boundary(text, offset) {
  if (offset <= 0 || offset >= text.length) {
    return true;
  }
  const previous = text.charCodeAt(offset - 1);
  const current = text.charCodeAt(offset);
  return !(previous >= 55296 && previous <= 56319 && current >= 56320 && current <= 57343);
}
export {
  contentRedactionPolicySchema,
  contentScreeningDetectionSchema,
  contentScreeningDetectionsSchema,
  contentScreeningProviderNameSchema,
  contentScreeningProviderResultSchema,
  isContentScreeningDetectionWithinText,
  textContentScreeningSchema
};
//# sourceMappingURL=schema.js.map
